import { Component } from '@angular/core';

@Component({
    selector: 'homelayout',
  templateUrl: './homelayout.component.html',
  styleUrls: ['./homelayout.component.scss']
})
export class HomeLayoutComponent {
    constructor() { }
}
